import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/main.css'
import VConsole from 'vconsole'
import TDesign from 'tdesign-mobile-vue';
// 引入组件库的少量全局样式变量
import 'tdesign-mobile-vue/es/style/index.css';
new VConsole()
createApp(App).use(store)
.use(router).use(createPinia()).use(TDesign).mount('#app')
